import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { StudentSearchComponent } from '../shared/student-search/student-search.component';
import { ThemeService } from '../_helpers/theming-engine/theme.service';
import { FeatureHelperService } from '../_helpers/feature-helper/feature-helper.service';
import { AuthenticationStateHelperService } from '../_helpers/authentication-state-helper/authentication-state-helper.service';

@Component({
    selector: 'app-students',
    templateUrl: './students.component.html',
    styleUrls: ['./students.component.css'],
    standalone: false
})
export class StudentsComponent implements OnInit {
  
  @ViewChild("studentSearch", { static: true }) childUtilityRefComponent: StudentSearchComponent;

  public hasStudentDataInsertPermission: boolean = false;

  constructor(
    public themeService: ThemeService,
    public router: Router,
    private featureHelperService: FeatureHelperService,
    private authenticationStateHelper: AuthenticationStateHelperService
    ) { }

  ngOnInit() {
    let featureList = new Array<string>();
    featureList.push(
      "StudentDataSearch",
      "StudentDataInsert");

    let currentUserFeatures = this.featureHelperService.checkFeaturePermissions(featureList);

    if (!currentUserFeatures.filter(f => f.feature === "StudentDataSearch")[0].enabled) {
      console.error("User does not have the required permissions to view the student search screen");
      this.router.navigate(['/login'], { queryParams: { returnUrl: window.location.pathname }});
      this.authenticationStateHelper.unauthorizedToken = true;
    }

    if (currentUserFeatures.filter(f => f.feature === "StudentDataInsert")[0].enabled) {
      this.hasStudentDataInsertPermission = true;
    }
  }

}
